/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AtomicCarousel } from "@farmlands/atomic-io";
import { useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import { selectConfigByKey } from "../firebase/remote-config/remoteConfig.slice";

import { ATOMIC_STREAM_DASHBOARD_PROMOTIONS, useAtomic } from "./AtomicProvider";

export const DashboardPromotionsAtomic = () => {
  const atomicEnabled = useSelector(selectConfigByKey("atomicEnabled"));
  const atomicPromotionsEnabled = useSelector(selectConfigByKey("atomicPromotionsEnabled"));
  const { atomicReady, onLinkButtonPressed } = useAtomic();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const cardWidth = isSm ? (window.innerWidth / 100) * 60 : 354;

  if (!atomicPromotionsEnabled || !atomicEnabled || !atomicReady) {
    return null;
  }

  return (
    <AtomicCarousel
      title="Promotions"
      containerId={ATOMIC_STREAM_DASHBOARD_PROMOTIONS}
      cardWidth={cardWidth}
      hideWithoutItems
      atomicReady={atomicReady}
      onLinkButtonPressed={onLinkButtonPressed}
    />
  );
};
